import React, { useEffect} from 'react'
import GroupHeader from './GroupHeader';
import PlaylistGroup from './PlaylistGroup';
import { useSelector } from 'react-redux'

const GroupsComponent = (props) =>{

    const { playlistGroups } = useSelector(state => state.playlistGroups)

    useEffect(()=>{

        if (playlistGroups && playlistGroups.length){
            let group = playlistGroups.find(g=>g.id===parseInt(props.group_id))
            if (group) {
                props.setActiveGroup(group)
            } else {
                props.setActiveGroup(playlistGroups[0])
                localStorage.setItem('group_id', playlistGroups[0].id)
            }

        }

    },[playlistGroups])



    return(
        <div className = 'w-100 bg-bluedark pt-1 pt-md-5' style={{backgroundColor: '#07294c'}}>
            <div className="col-12 pt-1 pt-md-3 d-flex flex-column justify-content-center align-items-center">
                {
                    props.activeGroup &&
                    <GroupHeader
                        activeGroup={props.activeGroup}
                        setActiveGroup={props.setActiveGroup}
                        onGroupClick={props.onGroupClick}
                        groups={playlistGroups}
                        groupsRef={ props.groupsRef}
                    />
                }
                </div>

                {
                    props.activeGroup &&
                    <PlaylistGroup
                        activeGroup={props.activeGroup}
                        setActiveGroup={props.setActiveGroup}
                        slideClickHandler={props.slideClickHandler}
                        showAllPath={props.showAllPath}
                    />
                }


       </div>
   )
}


export default GroupsComponent;